import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import Footer from "../../components/Footer";
import { Styles } from "./styles/blogDetails.js";
import axios from "axios";
import { Constant, imageDomain } from "../../helper/Constants.js";

class BlogDetails extends Component {
  state = {
    blog: null,
    loading: true,
    error: null,
  };

  componentDidMount() {
    this.fetchBlog();
  }

  // get id from last segment of pathname
  getIdFromPath = () => {
    try {
      const parts = window.location.pathname.split("/").filter(Boolean);
      return parts[parts.length - 1];
    } catch (e) {
      return null;
    }
  };

  // build full image url from poster path
  buildImageUrl = (poster) => {
    if (!poster)
      return process.env.PUBLIC_URL + "/assets/images/default-blog.jpg";
    if (/^https?:\/\//i.test(poster)) return poster;
    // poster may already contain leading slash
    const cleanPoster = poster.startsWith("/") ? poster.slice(1) : poster;
    if (imageDomain) return imageDomain.replace(/\/+$/, "") + "/" + cleanPoster;
    return (process.env.PUBLIC_URL || "") + "/" + cleanPoster;
  };

  fetchBlog = async () => {
    const id = this.getIdFromPath();
    if (!id) {
      this.setState({ loading: false, error: "Blog id not found in URL." });
      return;
    }

    this.setState({ loading: true, error: null });

    try {
      const base =
        (Constant && Constant.getUrls && Constant.getUrls.getAllBlogs) ||
        "/api/blogs";
      const url = base.endsWith("/") ? base + id : base + "/" + id;

      const resp = await axios.get(Constant.getUrls.getAllBlogs + "/" + id);
      // prefer resp.data.data or resp.data
      const payload = resp?.data?.data ?? resp?.data ?? null;
      // sometimes payload itself contains the blog, sometimes wrapped in data.data
      const blog = payload?.data ?? payload;

      if (!blog) {
        this.setState({ blog: null, loading: false, error: "Blog not found." });
        return;
      }

      this.setState({ blog, loading: false, error: null });
    } catch (err) {
      console.error("Failed to fetch blog:", err);
      this.setState({
        blog: null,
        loading: false,
        error:
          err?.response?.data?.message || err.message || "Failed to fetch blog",
      });
    }
  };

  render() {
    const { blog, loading, error } = this.state;
    const title = blog?.blogs_title || blog?.title || "Untitled";
    const poster = blog?.blogs_poster || blog?.poster || blog?.image || "";
    const description =
      blog?.blog_content || blog?.content || blog?.description || "";

    return (
      <Styles>
        <div className="main-wrapper blog-details-page">
          <Header/>
          <BreadcrumbBox title="Blog Details" />

          <section className="blog-details-area">
            <Container>
              <Row>
                <Col lg="12" md="12" sm="12">
                  <div className="blog-details-box">
                    {loading ? (
                      <p style={{ textAlign: "center" }}>Loading...</p>
                    ) : error ? (
                      <p style={{ textAlign: "center", color: "red" }}>
                        {error}
                      </p>
                    ) : (
                      <>
                        {/* Image */}
                        {poster ? (
                          <div
                            className="blog-details-banner"
                            style={{ textAlign: "center", marginBottom: 20 }}
                          >
                            <img
                              src={this.buildImageUrl(poster)}
                              alt={title}
                              className="img-fluid"
                              style={{ maxWidth: "100%", height: "auto" }}
                            />
                          </div>
                        ) : null}

                        {/* Title */}
                        <div className="heading" style={{ marginBottom: 16 }}>
                          <h4>{title}</h4>
                        </div>

                        {/* Description (render HTML as provided by backend) */}
                        <div
                          className="blog-details-desc"
                          dangerouslySetInnerHTML={{
                            __html:
                              description || "<p>No description available.</p>",
                          }}
                        />
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          <Footer />
        </div>
      </Styles>
    );
  }
}

export default BlogDetails;